import { get } from 'lodash'

/*
 * Shift iterable form fields up, with possibility to clear last item.
 * Can shift group of fields.
 * Example:
 *
 * formFields: {
 *   field1: { value: 1 },
 *   field2: { value: 2 },
 *   field3: { value: null },
 * }
 *
 * handleShiftField({ fieldsNames: 'field', index: 1, clearLastItem: false})
 *
 * formFields: {
 *   field1: { value: 2 },
 *   field2: { value: 3 },
 *   field3: { value: 3 },
 * }
 */

export const handleShiftFields =
  ({ formData, handleFieldsChange, handleFieldsUntouch }) =>
  ({ fieldsNames, index, clearLastItem = true }) => {
    let fieldsToUpdate = {}
    let fieldsToUntouch = []
    const fieldsNamesToIterate = Array.isArray(fieldsNames) ? fieldsNames : [fieldsNames]

    fieldsNamesToIterate.forEach(fieldName => {
      const fieldsKeys = Object.keys(formData).filter(key => !!key.startsWith(fieldName))
      const keyToShift = `${fieldName}${index}`
      const fieldToShift = formData[keyToShift]
      const shiftIndex = fieldsKeys.findIndex(item => item === keyToShift)

      if (fieldToShift) {
        for (let i = shiftIndex; i < fieldsKeys.length; i++) {
          const currentFieldKey = fieldsKeys[i]
          const nextFieldKey = fieldsKeys[i + 1]
          const nextField = formData[nextFieldKey]
          const isNextFieldTouched = get(nextField, 'meta.isTouched')

          if (nextField) {
            // handle shift inside of list
            fieldsToUpdate[currentFieldKey] = nextField.value

            if (!isNextFieldTouched) {
              fieldsToUntouch.push(currentFieldKey)
            }
          } else {
            // handle last item in list

            if (clearLastItem) {
              fieldsToUpdate[currentFieldKey] = null
            } else {
              fieldsToUntouch.push(currentFieldKey)
            }
          }
        }
      }
    })

    handleFieldsChange(fieldsToUpdate)
    handleFieldsUntouch(fieldsToUntouch)
  }
